import useAppSelector from "@/core/helpers/useAppSelector";
import { emailConfirmedSelector, pinConfirmedSelector, sighUpSelector } from "@/domains/auth/slice";
import AuthSignUpConfirmEmailContainer from "@/domains/auth/containers/sign-up/AuthSignUpConfirmEmailContainer.tsx";
import AuthSignUpFormContainer from "@/domains/auth/containers/sign-up/AuthSignUpFormContainer.tsx";
import AuthSignUpPinContainer from "@/domains/auth/containers/sign-up/AuthSignUpPinContainer.tsx";
import AuthSignUpSuccessContainer from "@/domains/auth/containers/sign-up/AuthSignUpSuccessContainer.tsx";

export default function AuthSignUpContainer() {
  const { email } = useAppSelector(sighUpSelector);
  const emailConfirmed = useAppSelector(emailConfirmedSelector);
  const pinConfirmed = useAppSelector(pinConfirmedSelector);

  if (emailConfirmed) {
    if (pinConfirmed) {
      return <AuthSignUpSuccessContainer />;
    }
    return <AuthSignUpPinContainer />;
  }

  if (email) {
    return <AuthSignUpConfirmEmailContainer />;
  }

  return <AuthSignUpFormContainer />;
}
